module.exports = __webpack_public_path__ + "img/5.c8ce80af.png";